import React from 'react';
import Colors from '../../../utils/colors';

class BasicInput extends React.Component {
  state = { value: '' };

  componentDidMount() {
    this.setState({ value: this.props.value || '' });
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    this.props.updateValue(event);
  }

  render() {
    // const borderColor = this.props.border ? this.props.border : 'blue';
    const color = Colors.inputColors(this.props.border);

    const classes = `block w-full border-gray-300 rounded-md focus:ring focus:ring-opacity-50 sm:text-sm sm:leading-5 ${color.border} focus:outline-none ${color.focusBorder}`;
    return (
      <input
        className={classes}
        onChange={this.handleChange}
        name={this.props.name}
        id={this.props.name}
        type={this.props.type}
        disabled={!!this.props.submitting}
        placeholder={this.props.field.placeholder}
        value={this.state.value}
      />
    );
  }
};

export default BasicInput;